/** Build a Schema.org BreadcrumbList JSON-LD object. */
export function buildBreadcrumbSchema(siteUrl, items) {
  const origin = siteUrl.replace(/\/+$/, '');
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.path === '/' ? `${origin}/` : `${origin}${item.path}`,
    })),
  };
}
